import { Checkbox, Empty, Spin } from 'antd'
import Button from 'components/Button'
import FilterDiv from 'components/FilterDiv'
import Pagination from 'components/Pagination'
import SearchInput from 'components/SearchInput'
import { TableTop } from 'components/UIComponents/TableSearchFilter/Style/style'
import NoInterview from 'components/icons/NoInterview.png'
import moment from 'moment'
import React, { useCallback, useEffect, useState } from 'react'
import { EmptyElement } from '../../../../components/CommonStyles'
import ConsentReasonDrawer from '../../../../components/ConsentReasonDrawer'
import CloseRoleDrawer from '../../../../components/UIComponents/CloseRolePopup'
import SucessfullPopup from '../../../../components/UIComponents/CloseRolePopup/SucessfullModelPopup'
import SuccessIcon from '../../../../components/icons/SubmitCloseIcon'
import ApprovedIcon from '../../../../components/icons/TPORequestsIcons/ApprovedIcon'
import DeclinedIcon from '../../../../components/icons/TPORequestsIcons/DeclinedIcon'
import ApprovedModelIcon from '../../../../components/icons/TPORequestsIcons/PopupIcon/ApprovedModelIcon'
import DeclinedPopupIcon from '../../../../components/icons/TPORequestsIcons/PopupIcon/DeclinedPopupIcon'
import { toCamelCase } from '../../../../utils/helpers'
import { SearchWidth, TableCount } from '../../../Events/EventRole/style'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from '../../../JobRoles/PageHeader/JobRoleFilter/style'
import { ImageAvatar } from '../../../Placement/style'
import { StyledTableSqareUpdate } from '../../../RuleEngine/Components/Dashboard/style'
import { EmptyWrapper } from '../../../Users/Style/style'
import {
  ApprovedButton,
  CustomTag,
  EndDateCell,
  EndDateDiv,
  NameCell,
  PriorityLabelDiv,
  ReasonNonText,
  ReasonText,
  SelectedContainar,
  SelectedText,
  StyledDeatilsText,
  StyledJobTitle,
  StyledNameText,
  TableColorCircle,
  TablePriorityLabel,
} from '../../style'
import CompanyFilter from '../Filters/CompanyFilter'
import PriorityFilter from '../Filters/PriorityFilter'
import RoleFilter from '../Filters/RolesFilter'
import RuleFilter from '../Filters/RuleFilter'
import { sendNotificationBulkEmail, sendNotificationBulkEmailWhatsapp, sendInAppNotification } from 'modules/Students/actions'
import ApprovalConfirmedTemplate from 'components/EmailTemplate/ApprovalConfirmedTemplate'
import RequestDeniedTemplate from 'components/EmailTemplate/RequestDeniedTemplate'
import ExternalLinkApprovalTemplate from 'components/EmailTemplate/ExternalLinkApprovalTemplate'
import ReactDOMServer from 'react-dom/server'
import { useDispatch, useSelector } from 'react-redux'
const TpoApprovalTable = ({
  selectedCard,
  userList,
  handleCompanyCheckboxChange,
  handlePriorityCheckboxChange,
  handleRolesCheckboxChange,
  handleRulesCheckboxChange,
  setPageSelectedCount,
  selectedCompany,
  selectedPriorities,
  selectedRoles,
  selectedRules,
  companyData,
  prioritiesData,
  rolesDatas,
  rulesDatas,
  companySearchValue,
  setCompanySearchValue,
  handleCompanySearch,
  roleSearchValue,
  setRoleSearchValue,
  handleRoleSearch,
  handleApplyFilter,
  setPageNum,
  pageNum,
  searchValue,
  setSearchValue,
  loading,
  updateAllRequestList,
  setIsSelectAllChecked,
  isSelectAllChecked,
  setSelectedStudentRoles,
  selectedFlag,
  setSortBy,
  setOrder,
  getTpoUserList,
  setSelectAll,
  selectAll,
  getConsentDrawerList,
  isMenuOpen,
  setIsMenuOpen,
  handleNameClick,
  getTPOMetrics,
  handleCardClick,
  setMetricsData,
  selectedKeys,
  setSelectedKeys,
  handleFilterCancel,
}) => {
  const dispatch = useDispatch()
  const institute = useSelector(state => state.auth.instituteDetails)
  const userData = useSelector(state => state.auth.userData)
  const userRole = useSelector(state => state.auth.userRoleList)
  
  const getRoleName = id => {
    let roleName = userRole?.filter(data => data?.id === id)[0]?.name
    return roleName ?? 'Admin'
  }
  
  const getUserRoleName = () => {
    return getRoleName(
      userData?.pluginlive_id
        ? userData?.admin?.instRoleId
        : userData?.admin_role_id ?? userData?.role_id
    )
  }

  const [showApprovalDrawer, setShowApprovalDrawer] = useState(false)
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)
  const [showDeclinedDrawer, setShowDeclinedDrawer] = useState(false)
  const [showDeclinePopup, setShowDeclinePopup] = useState(false)
  const [consentReasonDrawer, setConsentReasonDrawer] = useState(false)
  const [rolesData, setRolesData] = useState([])
  const [amountCount, setAmountCount] = useState()
  const [selectedRowData, setSelectedRowData] = useState(null)

  const handleOpenConsentReasonDrawer = async (
    studentId,
    record,
    amountCount
  ) => {
    const placementTypeList =
      record?.restricted_reason?.isOfferLimit?.placementType

    const reasonList = record?.restricted_reason
    let updatedPayload = {
      placementType: placementTypeList,
    }

    if (reasonList?.isAbsentLimit && !reasonList?.isAbsentLimit.isEligible) {
      updatedPayload.isAbsentList = true
    }

    if (reasonList?.isOfferLimit && !reasonList?.isOfferLimit.isEligible) {
      updatedPayload.isOfferList = true
    }

    if (
      reasonList?.isInitialMissedRole &&
      !reasonList?.isInitialMissedRole.isEligible
    ) {
      updatedPayload.isInitialMissedRole = true
    }

    try {
      const consentDrawerReasonData = await getConsentDrawerList(
        studentId,
        updatedPayload
      )

      if (consentDrawerReasonData) {
        setRolesData(consentDrawerReasonData)
        setAmountCount(amountCount)
        setConsentReasonDrawer(true)
      } else {
        //console.log('No data received or error occurred.')
      }
    } catch (error) {
      console.error('Error opening consent reason drawer:', error)
    }
  }
  const handleCloseConsentReasonDrawer = () => {
    setConsentReasonDrawer(false)
  }
  const handleCloseClick = () => {
    setShowApprovalDrawer(false)
    // setShowSuccessPopup(true)
  }

  const closePopup = () => {
    setShowSuccessPopup(false)
    setSelectedStudentRoles([])
    setSelectAll(false)
  }

  const showApprovalConfirm = () => {
    setShowApprovalDrawer(true)
  }

  const showDeclineConfirm = () => {
    setShowDeclinedDrawer(true)
  }

  const closeDeclinePopup = () => {
    setShowDeclinePopup(false)
    setSelectedStudentRoles([])
    setSelectAll(false)
  }

  const handleDeclineCloseClick = () => {
    setShowDeclinedDrawer(false)
    // setShowDeclinePopup(true)
    // selectedStudentRoles([])
    // setPageNum(0)
  }
  const menu = (
    <MenuFlex column style={{ width: 'max-content' }}>
      <StyledTab
        width={'35%'}
        padding={'20px'}
        border={true}
        tabPosition={'left'}
        type="card"
        items={[
          // {
          //   label: 'Priority',
          //   key: '1',
          //   children: (
          //     <PriorityFilter
          //       handlePriorityCheckboxChange={handlePriorityCheckboxChange}
          //       selectedPriorities={selectedPriorities}
          //       prioritiesData={prioritiesData}
          //     />
          //   ),
          // },
          ...(selectedFlag !== 'APPROVED' && selectedFlag !== 'DECLINED'
            ? [
                {
                  label: 'Priority',
                  key: '1',
                  children: (
                    <PriorityFilter
                      handlePriorityCheckboxChange={
                        handlePriorityCheckboxChange
                      }
                      selectedPriorities={selectedPriorities}
                      prioritiesData={prioritiesData}
                    />
                  ),
                },
              ]
            : []),
          {
            label: 'Company',
            key: '2',
            children: (
              <CompanyFilter
                selectedCompany={selectedCompany}
                handleCompanyCheckboxChange={handleCompanyCheckboxChange}
                companyData={companyData}
                companySearchValue={companySearchValue}
                setCompanySearchValue={setCompanySearchValue}
                handleCompanySearch={handleCompanySearch}
              />
            ),
          },
          {
            label: 'Roles',
            key: '3',
            children: (
              <RoleFilter
                handleRolesCheckboxChange={handleRolesCheckboxChange}
                selectedRoles={selectedRoles}
                rolesDatas={rolesDatas}
                roleSearchValue={roleSearchValue}
                setRoleSearchValue={setRoleSearchValue}
                handleRoleSearch={handleRoleSearch}
              />
            ),
          },
          {
            label: 'Rule',
            key: '4',
            children: (
              <RuleFilter
                handleRulesCheckboxChange={handleRulesCheckboxChange}
                selectedRules={selectedRules}
                rulesDatas={rulesDatas}
              />
            ),
          },
        ]}
      />

      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={() => handleFilterCancel()} />
        <Button.Primary
          text="Apply Filter"
          onClick={() => handleApplyFilter()}
        />
      </SubmitFlex>
    </MenuFlex>
  )
  const currentDate = new Date()
  const onSelectAllChange = checked => {
    // setSelectAll(checked)
    setSelectAll(false)
    if (checked) {
      setIsSelectAllChecked(true)
      const allSelectedRoles = userList?.data?.result?.map(item => ({
        ...item,
      }))

      const allSelectedKeys = allSelectedRoles.filter(item => {
        return new Date(item.end_date) > currentDate
      })

      setSelectedKeys(allSelectedKeys)
      setSelectedRowData('')
      setPageSelectedCount(allSelectedKeys.length) 
    } else {
      setSelectedKeys([])
      setIsSelectAllChecked(false)
      setSelectedRowData('')
      setPageSelectedCount(0) 
    }
  }

  const onRowSelectChange = (value, checked) => {
    let updatedSelectedKeys = []
    let reasons = []

    if (checked) {
      updatedSelectedKeys = [...selectedKeys, value]

      const restrictedReason = value.restricted_reason
      const contentList =
        restrictedReason?.isOfferLimit?.exceptionalFor?.split(',') || []
      const amountCount = restrictedReason?.isOfferLimit

      if (restrictedReason) {
        if (restrictedReason.isAbsentLimit) {
          reasons.push(
            `Restricted due to failing to attend ${restrictedReason.isAbsentLimit.used} scheduled evaluations.`
          )
        }
        if (restrictedReason.isOfferLimit) {
          reasons.push(
            `Applying with   ${
              amountCount?.placementType == 'OFFER_ACCEPTED'
                ? 'Offer Accepted'
                : 'Intent to Offer'
            } for ${restrictedReason.isOfferLimit.used} roles.`
          )

          if (amountCount?.isMinimumThresholdReached === true) {
            reasons.push('Exceeded minimum threshold')
          }

          if (contentList?.includes('absoluteAmount')) {
            reasons.push(
              `Applying for a role with a package lower than ${amountCount?.absoluteAmount}`
            )
          }

          if (contentList?.includes('multiplesAmount')) {
            reasons.push(
              `Applying for a compensation range lower {''}than ${amountCount?.multiples}x the current CTC`
            )
          }

          if (contentList?.includes('compensationRange')) {
            reasons.push(
              `Applying for a lower comp. range"
                      ${amountCount?.currentPackage?.name}" role. "
                      ${
                        amountCount?.placementType == 'OFFER_ACCEPTED'
                          ? 'Offer Accepted'
                          : 'Intent to Offer'
                      }
                      " role is from the
                        ${
                          amountCount?.rolePackage?.name
                            ? `"${amountCount?.rolePackage?.name}"`
                            : null
                        }
                      
                      comp. range.`)
          }
        }
        if (restrictedReason.isApplyLimit) {
          reasons.push(
            `Applied for ${restrictedReason.isApplyLimit.used} roles.`
          )
        }
        if (restrictedReason.isInitialMissedRole) {
          reasons.push(
            `Applying after missing initial ${restrictedReason.isInitialMissedRole.used} roles.`
          )
        }
      }

      setSelectedRowData({
        reason: reasons.join(' '),
      })

      if (updatedSelectedKeys.length !== 1) {
        setSelectedRowData({
          reason: '',
        })
      }
    } else {
      updatedSelectedKeys = selectedKeys.filter(item => item?.id !== value?.id)
    }

    setSelectedKeys(updatedSelectedKeys)
    setPageSelectedCount(updatedSelectedKeys.length)

    setIsSelectAllChecked(
    updatedSelectedKeys.length === userList?.data?.result?.length
    )
  }

  const columns = [
    ...(selectedCard !== 3
      ? [
          {
            title: (
              <Checkbox
                onChange={e => onSelectAllChange(e.target.checked)}
                checked={isSelectAllChecked || selectAll}
                indeterminate={
                  selectedKeys.length > 0 &&
                  selectedKeys.length < (userList?.data?.result?.length || 0)
                }
                disabled={
                  selectedFlag === 'DECLINED' &&
                  userList?.data?.result?.every(
                    record => record.end_date < record.current_date
                  )
                }
              />
            ),
            dataIndex: 'select',
            key: 'select',
            align: 'center',
            width: '5%',
            render: (_, record) => {
              return (
                <Checkbox
                  checked={selectedKeys.some(item => item.id === record.id)}
                  onChange={e => onRowSelectChange(record, e.target.checked)}
                  disabled={
                    selectedFlag === 'DECLINED' &&
                    record.end_date < record.current_date
                  }
                />
              )
            },
          },
        ]
      : []),

    {
      title: (
        <div style={{ padding: selectedCard === 3 ? '10px' : '0px' }}>Name</div>
      ),
      dataIndex: 'name',
      key: 'name',
      // sorter: true,
      // sortDirections: ['ascend', 'descend'],

      render: (_, record) => (
        <NameCell
          onClick={() => handleNameClick(record)}
          style={{ padding: selectedCard === 3 ? '10px' : '0px' }}
        >
          <ImageAvatar
            src={record?.profile_url}
            width={'50px'}
            height={'50px'}
          />
          <div>
            <StyledNameText>{`${record.first_name} ${record.last_name}`}</StyledNameText>
            <small>{record.uni_roll_no}</small>
          </div>
        </NameCell>
      ),
    },
    {
      title: 'Contact Details',
      dataIndex: 'contact',
      key: 'contact',
      render: (_, contact) => (
        <div>
          <StyledDeatilsText>{`${contact?.contact_number}`}</StyledDeatilsText>
          <StyledDeatilsText>{contact?.primary_email}</StyledDeatilsText>
        </div>
      ),
    },

    {
      title: 'Consent Reason',
      dataIndex: 'reason',
      key: 'reason',
      width: '20%',
      render: (_, record) => {
        const content = []
        if (record.restricted_reason?.isAbsentLimit) {
          let { used, limit, isEligible } =
            record.restricted_reason.isAbsentLimit
          if (used >= limit && !isEligible) {
            content.push(
              <EmptyElement
                onClick={() =>
                  handleOpenConsentReasonDrawer(record.student_id, record)
                }
              >
                <ReasonText>
                  Restricted due to failing to attend &nbsp;
                  <b>{used} scheduled evaluations.</b>
                </ReasonText>
              </EmptyElement>
            )
          }
        }
        const isOfferLimit = record.restricted_reason?.isOfferLimit
        if (isOfferLimit) {
          let { used, limit, isEligible, exceptionalFor } = isOfferLimit
          const contentList = exceptionalFor?.split(',') || []
          const amountCount = isOfferLimit
          if ((used >= limit, !isEligible)) {
            content.push(
              <EmptyElement
                onClick={() =>
                  handleOpenConsentReasonDrawer(
                    record.student_id,
                    record,
                    amountCount
                  )
                }
              >
                <ReasonText>
                  Applying with&nbsp;
                  {amountCount?.placementType == 'OFFER_ACCEPTED'
                    ? 'Offer Accepted'
                    : 'Intent to Offer'}
                  &nbsp; from <b>{used} roles</b>
                </ReasonText>

                {amountCount?.isMinimumThresholdReached && (
                  <ReasonText>Exceeded minimum threshold</ReasonText>
                )}

                {contentList?.includes('absoluteAmount') && (
                  <ReasonText>
                    Applying for a role with a package lower than &nbsp;
                    <b>{amountCount?.absoluteAmount}</b>
                  </ReasonText>
                )}

                {contentList?.includes('multiplesAmount') && (
                  <ReasonText>
                    Applying for a compensation range lower {''}than &nbsp;
                    <b>{amountCount?.multiples}</b>x &nbsp;the current CTC
                  </ReasonText>
                )}
                {contentList?.includes('compensationRange') && (
                  <ReasonText>
                    Applying for a <b>lower comp. range</b> &nbsp; "
                    {amountCount?.currentPackage?.name}"&nbsp;role. "
                    {amountCount?.placementType == 'OFFER_ACCEPTED'
                      ? 'Offer Accepted'
                      : 'Intent to Offer'}
                    " &nbsp; role is from the &nbsp; &nbsp;
                    {amountCount?.rolePackage?.name
                      ? `"${amountCount?.rolePackage?.name}"`
                      : null}
                    &nbsp; comp. range.
                  </ReasonText>
                )}
              </EmptyElement>
            )
          }
        }

        const isApplyLimit = record?.restricted_reason?.isApplyLimit
        if (isApplyLimit) {
          let { used, limit, isEligible } = isApplyLimit
          if (used >= limit && !isEligible) {
            content.push(
              <div>
                <ReasonNonText>
                  Applied for &nbsp;<b>{used}</b>&nbsp; roles
                </ReasonNonText>
              </div>
            )
          }
        }

        if (record.restricted_reason?.isInitialMissedRole) {
          let { used, limit, isEligible } =
            record.restricted_reason.isInitialMissedRole
          if (used >= limit && !isEligible) {
            content.push(
              <EmptyElement
                onClick={() =>
                  handleOpenConsentReasonDrawer(record.student_id, record)
                }
              >
                <ReasonText>
                  Applying after missing initial &nbsp;<b>{used}</b>&nbsp;
                  roles.
                </ReasonText>
              </EmptyElement>
            )
          }
        }
        return content.length > 0 ? content : null
      },
    },
    {
      title: 'Job Title & Company Name',
      dataIndex: 'job',
      key: 'job',
      render: (_, job) => (
        <>
          <StyledJobTitle> {toCamelCase(job?.tittle)} </StyledJobTitle>
          <StyledDeatilsText>
            {' '}
            {toCamelCase(job?.publisher_name)}{' '}
          </StyledDeatilsText>
        </>
      ),
    },

    {
      title:
        selectedCard === 3
          ? 'Approval Date'
          : selectedCard === 4
          ? 'Declined Date'
          : 'App. End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (_, record) => {
        const currentDate = new Date()
        const targetDate = new Date(record?.end_date)

        const differenceInMilliseconds = targetDate - currentDate

        // Break down the difference into days, hours, minutes, and seconds
        const totalSeconds = Math.floor(differenceInMilliseconds / 1000)
        const totalMinutes = Math.floor(totalSeconds / 60)
        const totalHours = Math.floor(totalMinutes / 60)
        const differenceInDays = Math.floor(totalHours / 24)
        const remainingHours = totalHours % 24
        const remainingMinutes = totalMinutes % 60
        const remainingSeconds = totalSeconds % 60

        const formattedEndDate = record?.end_date
          ? new Date(record.end_date)
              ?.toISOString()
              ?.split('T')[0]
              ?.split('-')
              ?.reverse()
              ?.join('/')
          : ''

        const formattedDeclinedDate = record?.action_date
          ? moment(record.action_date).format('DD/MM/YYYY')
          : ''

        let tagColor

        const fractionalDay =
          differenceInDays +
          remainingHours / 24 +
          remainingMinutes / (24 * 60) +
          remainingSeconds / (24 * 60 * 60)

        if (fractionalDay < 3) {
          tagColor = '#F54B56' // High Priority
        } else if (fractionalDay >= 3 && fractionalDay <= 5) {
          tagColor = '#FF7400' // Medium Priority
        } else if (fractionalDay > 5 && fractionalDay <= 5.5) {
          tagColor = '#FFB400' // Low Priority for extra hours (up to 5.5 days)
        } else {
          tagColor = '#CFCFCF' // Less Priority
        }
        const displayText =
          (differenceInDays > 0 || remainingMinutes > 0 || remainingSeconds > 0) 
            ? `Ends in ${differenceInDays} day${
                differenceInDays > 1 ? 's' : ''
              }`
            : 'Ended'

        // ** Extract the Rendered Component Logic **
        const getContent = () => {
          if (selectedCard === 3) {
            return (
              <EndDateDiv>
                <span>{formattedDeclinedDate}</span>
              </EndDateDiv>
            )
          } else if (selectedCard === 4 && record.tpo_status !== -1) {
            return (
              <EndDateDiv>
                <div style={{ marginLeft: '8px' }}>
                  <div>Approval Lapsed</div>
                  <div>{formattedEndDate}</div>
                </div>
              </EndDateDiv>
            )
          } else if (selectedCard === 4 && record.tpo_status === -1) {
            return (
              <EndDateDiv>
                <span>{formattedDeclinedDate}</span>
              </EndDateDiv>
            )
          } else {
            return (
              <>
                <CustomTag bgColor={tagColor} />
                <EndDateDiv>
                  <span>{displayText}</span>
                  <span> ({formattedEndDate})</span>
                </EndDateDiv>
              </>
            )
          }
        }

        return <EndDateCell>{getContent()}</EndDateCell>
      },
    },
  ]
  const tablePriorities = [
    { label: 'Priority 1 (< 3 days)', color: '#F54B56', index: 1 },
    { label: 'Priority 2 (3-5 days)', color: '#FF7400', index: 2 },
    { label: 'Less Priority', color: '#CFCFCF', index: 3 },
  ]

  const onPageChange = num => {
    setPageNum(num - 1)
    setSelectedKeys([])
    setPageSelectedCount(0)
    setIsSelectAllChecked(false)
  }

  // Search Functions
  const delaySaveToDb = useCallback(
    debounce(text => {
      setPageNum(0)
      setSearchValue(text)
    }, 1000),
    []
  )

  function debounce(fn, delay) {
    let timer
    return function () {
      const context = this
      const args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  const handleSearch = e => {
    const text = e.target.value
    delaySaveToDb(text)
  }

  const handleApproveClick = async () => {
    try {
      let data = selectedKeys?.map(item => ({
        studentId: item.student_id,
        roleId: item.role_id,
      }))
      const rolesToSend = isSelectAllChecked ? [] : data

     const result =  await updateAllRequestList(
        selectedFlag,
        rolesToSend,
        selectAll,
        1,
        1,
        searchValue
      )
      //Here
      // Send notifications to all approved students
      let declinedStudents = result?.data?.tpoApprovalMasterData?.roleData
      if (declinedStudents?.length > 0 ) {
        try {
          // Process each selected student
          const emailPayloads = []
          const whatsappPayloads = []
          const inAppNotifications = []
          
          declinedStudents.forEach(item => 
          
          {
            if(item?.roleDetails?.externalLink == null){
            // Format student name
            const studentName =  item?.studentDetails?.full_name
            
            // Prepare email data
            const emailData = {
              studentName,
              roleName: item?.roleDetails?.roleName,
              companyName: item?.roleDetails?.companyName,
              placementOfficerName: userData?.first_name + ' ' + userData?.last_name,
              placementOfficerContact: userData?.phone_number || institute?.contact_number
            }
            
            // Render email template
            const emailTemplate = ReactDOMServer.renderToString(
              <ApprovalConfirmedTemplate data={emailData} />
            )
            
            // Add to email payloads
            emailPayloads.push({
              to: item?.studentDetails?.primary_email,
              subject: `Approval Confirmed – Application Submitted for ${item?.roleDetails?.roleName}`,
              htmlBody: emailTemplate
            })
            
            // Add to WhatsApp payloads
            whatsappPayloads.push({
              to: item?.studentDetails?.contact_number.replace(/\D/g, ''),  // Remove non-digits from phone number
              templateName: 'tpo_application_approved',
              type: 'template',
              components: [
                {
                  type: 'BODY',
                  parameters: [
                    { type: 'TEXT', text: studentName }, // {{1}} - Student name
                    { type: 'TEXT', text: item?.roleDetails?.roleName }, // {{2}} - Role name
                    { type: 'TEXT', text: item?.roleDetails?.companyName } // {{3}} - Company name
                  ]
                }
              ]
            })
            
          
            
            // Add to in-app notifications
            inAppNotifications.push({
              ids: [item?.studentId ],
              userIds: [],
              roles: ["Student"],
              issuer: "institute",
              createFor: "student",
              inApp: true,
              body: `Your request to apply for the ${item?.roleDetails?.roleName} role at ${item?.roleDetails?.companyName} has been approved. Your application has now been automatically submitted. No further action is required.`,
              tag: "Role",
              actions: [{
                name: "View",
                deep_link: `roles/viewrole/${item?.roleId}`,
                route: `roles/viewrole/${item?.roleId}`,
                parameters: {}
              }]
            })
          }
          })
          
          // Send email notifications
          if (emailPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmail(emailPayloads))
          }
          
          // Send WhatsApp notifications
          if (whatsappPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmailWhatsapp(whatsappPayloads))
          }
          
          // Send in-app notifications
          if (inAppNotifications.length > 0) {
            const inAppObj = {
              notification: {
                students: inAppNotifications
              }
            }
            await dispatch(sendInAppNotification(inAppObj))
          }
        } catch (error) {
          console.error('Error sending approval notifications:', error)
        }
      }
      

      //please add it here

      if (declinedStudents?.length > 0) {
        try {
          // Process each selected student
          const emailPayloads = []
          const whatsappPayloads = []
          const inAppNotifications = []
          
          declinedStudents?.forEach(item => {
            // Format student name
            if(item?.roleDetails?.externalLink){
            const studentName = item?.studentDetails?.full_name
            
            // Format deadline date
            const deadlineDate = new Date(item?.roleDetails?.endDate).toLocaleDateString('en-IN', {
              day: 'numeric', 
              month: 'short', 
              year: 'numeric'
            })
            
            // Prepare email data
            const emailData = {
              studentName,
              roleName: item?.roleDetails?.roleName,
              companyName: item?.roleDetails?.companyName,
              deadlineDate,
              placementOfficerName: userData?.first_name + ' ' + userData?.last_name,
              placementOfficerContact: userData?.phone_number || institute?.contact_number
            }
            
            // Render email template
            const emailTemplate = ReactDOMServer.renderToString(
              <ExternalLinkApprovalTemplate data={emailData} />
            )
            
            // Add to email payloads
            emailPayloads.push({
              to: item?.studentDetails?.primary_email,
              subject: `Approval Received – Apply for ${item?.roleDetails?.roleName}`,
              htmlBody: emailTemplate
            })
            
            // Format deadline for WhatsApp
            const whatsappDeadline = new Date(item?.roleDetails?.endDate).toLocaleDateString('en-IN', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            })
            
            // Add to WhatsApp payloads
            whatsappPayloads.push({
              to: item?.studentDetails?.contact_number.replace(/\D/g, ''), // Remove non-digits from phone number
              templateName: 'tpo_application_external',
              type: 'template',
              components: [
                {
                  type: 'BODY',
                  parameters: [
                    { type: 'TEXT', text: studentName }, // {{1}} - Student name
                    { type: 'TEXT', text: item?.roleDetails?.roleName }, // {{2}} - Role name
                    { type: 'TEXT', text: item?.roleDetails?.companyName }, // {{3}} - Company name
                    { type: 'TEXT', text: whatsappDeadline } // {{4}} - Deadline date
                  ]
                }
              ]
            })
            
            // Add to in-app notifications
            inAppNotifications.push({
              ids: [item?.studentId],
              userIds: [],
              roles: ["Student"],
              issuer: "institute",
              createFor: "student",
              inApp: true,
              body: `Your request to apply for the ${item?.roleDetails?.roleName} role at ${item?.roleDetails?.companyName} has been approved. Submit your application before the deadline: ${deadlineDate}.`,
              tag: "Role",
              actions: [{
                name: "View",
                deep_link: `roles/viewrole/${item?.roleId}`,
                route: `roles/viewrole/${item?.roleId}`,
                parameters: {}
              }]
            })
          }
          })
          
          // Send email notifications
          if (emailPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmail(emailPayloads))
          }
          
          // Send WhatsApp notifications
          if (whatsappPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmailWhatsapp(whatsappPayloads))
          }
          
          // Send in-app notifications
          if (inAppNotifications.length > 0) {
            const inAppObj = {
              notification: {
                students: inAppNotifications
              }
            }
            await dispatch(sendInAppNotification(inAppObj))
          }
        } catch (error) {
          console.error('Error sending external link approval notifications:', error)
        }
      }
      setShowApprovalDrawer(false)
      setShowSuccessPopup(true)
      setSelectedKeys([])
      setSelectAll(false)
      handleCardClick(selectedCard)
      const metrics = await getTPOMetrics()
      setMetricsData(metrics)
    } catch (error) {
      console.error('Error during approval:', error)
    }
  }

  const handleDeclineClick = async () => {
    try {
      let data = selectedKeys?.map(item => ({
        studentId: item.student_id,
        roleId: item.role_id,
      }))
      const rolesToSend = isSelectAllChecked ? [] : data

     const result = await updateAllRequestList(
        selectedFlag,
        rolesToSend,
        selectAll,
        -1,
        0,
        searchValue
      )
      //here
      // Send notifications to all declined students
      let declinedStudents = result?.data?.tpoApprovalMasterData?.roleData
      if (declinedStudents?.length > 0) {
        try {
          // Process each selected student
          const emailPayloads = []
          const whatsappPayloads = []
          const inAppNotifications = []
          
          declinedStudents.forEach(item => {
            // Format student name
            const studentName = item?.studentDetails?.full_name
            
            // Prepare email data
            const emailData = {
              studentName,
              roleName: item?.roleDetails?.roleName,
              companyName: item?.roleDetails?.companyName,
              reason: selectedRowData.reason,
              placementOfficerName: userData?.first_name + ' ' + userData?.last_name,
              placementOfficerContact: userData?.phone_number || institute?.contact_number
            }
            
            // Render email template
            const emailTemplate = ReactDOMServer.renderToString(
              <RequestDeniedTemplate data={emailData} />
            )
            
            // Add to email payloads
            emailPayloads.push({
              to: item?.studentDetails?.primary_email,
              subject: `Request Denied – Application for ${item?.roleDetails?.roleName}`,
              htmlBody: emailTemplate
            })
            
            // Add to WhatsApp payloads
            whatsappPayloads.push({
              to: item?.studentDetails?.contact_number.replace(/\D/g, ''),  // Remove non-digits from phone number
              templateName: 'tpo_application_denied_uti',
              type: 'template',
              components: [
                {
                  type: 'BODY',
                  parameters: [
                    { type: 'TEXT', text: studentName }, // {{1}} - Student name
                    { type: 'TEXT', text: item?.roleDetails?.roleName }, // {{2}} - Role name
                    { type: 'TEXT', text: item?.roleDetails?.companyName }, // {{3}} - Company name
                    
                  ]
                }
              ]
            })
            
          
            
            // Add to in-app notifications
            inAppNotifications.push({
              ids: [item.studentId],
              userIds: [],
              roles: ["Student"],
              issuer: "institute",
              createFor: "student",
              inApp: true,
              body: `Your request to apply for the ${item?.roleDetails?.roleName} role at ${item?.roleDetails?.companyName} has been declined due to ${selectedRowData.reason}.`,
              tag: "Role",
              actions: [{
                name: "View",
                deep_link: `roles/viewrole/${item?.roleId}`,
                route: `roles/viewrole/${item?.roleId}`,
                parameters: {}
              }]
            })
          })
          
          // Send email notifications
          if (emailPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmail(emailPayloads))
          }
          
          // Send WhatsApp notifications
          if (whatsappPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmailWhatsapp(whatsappPayloads))
          }
          
          // Send in-app notifications
          if (inAppNotifications.length > 0) {
            const inAppObj = {
              notification: {
                students: inAppNotifications
              }
            }
            await dispatch(sendInAppNotification(inAppObj))
          }
        } catch (error) {
          console.error('Error sending decline notifications:', error)
        }
      }
      
      setShowDeclinedDrawer(false)
      setSelectedKeys([])
      setSelectAll(false)
      handleCardClick(selectedCard)
      const metrics = await getTPOMetrics()
      setMetricsData(metrics)
    } catch (error) {
      console.error('Error during decline:', error)
    }
  }

  const onSorting = (pagination, filter, sorter) => {
    setSortBy(sorter.field)
    setOrder(sorter.order)
    getTpoUserList(
      selectedFlag,
      pageNum,
      10,
      searchValue,
      sorter.field,
      sorter.order
    )
  }

  return (
    <div>
      {selectedCard < 3 && (
        <PriorityLabelDiv>
          {tablePriorities.map(({ label, color, index }) => {
            const shouldRender = selectedCard === 2 ? index !== 3 : true

            return (
              shouldRender && (
                <TablePriorityLabel key={index}>
                  <TableColorCircle color={color} />
                  <span> {label}</span>
                </TablePriorityLabel>
              )
            )
          })}
        </PriorityLabelDiv>
      )}
      <TableTop
        centerVertically
        style={{ paddingTop: '0px' }}
        customHeight={'3rem'}
      >
        <SearchWidth>
          <SearchInput
            width={'80%'}
            placeholder={'Search By Keyword'}
            bordered={false}
            value={searchValue}
            handleSearch={handleSearch}
          />
        </SearchWidth>
        <FilterDiv
          overlayMenu={menu}
          open={isMenuOpen}
          setOpen={setIsMenuOpen}
          onOpenChange={() => setIsMenuOpen(!isMenuOpen)}
          width={'15%'}
        />
        <TableCount>
          Showing {pageNum * 10 + userList?.data?.result?.length} of{' '}
          {userList?.data?.count}
        </TableCount>
      </TableTop>
      {selectedCard !== 3 && (
        <SelectedContainar>
          <SelectedText>Select</SelectedText>
          <ApprovedButton
            onClick={showApprovalConfirm}
            style={{
              pointerEvents:
                userList?.data?.result?.length === 0 ||
                selectedKeys?.length === 0
                  ? 'none'
                  : 'auto',
              opacity:
                userList?.data?.result?.length === 0 ||
                selectedKeys?.length === 0
                  ? 0.5
                  : 1,
            }}
          >
            <ApprovedIcon />
          </ApprovedButton>
          {selectedCard !== 4 && (
            <ApprovedButton
              onClick={showDeclineConfirm}
              style={{
                pointerEvents:
                  userList?.data?.result?.length === 0 ||
                  selectedKeys?.length === 0
                    ? 'none'
                    : 'auto',
                opacity:
                  userList?.data?.result?.length === 0 ||
                  selectedKeys?.length === 0
                    ? 0.5
                    : 1,
              }}
            >
              <DeclinedIcon />
            </ApprovedButton>
          )}
        </SelectedContainar>
      )}
      <StyledTableSqareUpdate
        columns={columns}
        dataSource={userList?.data?.result || []}
        bordered
        rowKey={record => record.id}
        onChange={onSorting}
        pagination={false}
        locale={{
          emptyText: (
            <EmptyWrapper center>
              {loading ? (
                <Spin />
              ) : (
                <Empty
                  image={NoInterview}
                  imageStyle={{ height: 360 }}
                  description={'All done. No approvals pending!'}
                />
              )}
            </EmptyWrapper>
          ),
        }}
      />

      <Pagination
        onChange={onPageChange}
        totalPages={userList?.data?.count}
        pageSize={10}
        current={pageNum + 1}
      />

      <ConsentReasonDrawer
        rolesData={rolesData}
        setConsentReasonDrawer={setConsentReasonDrawer}
        consentReasonDrawer={consentReasonDrawer}
        onClose={handleCloseConsentReasonDrawer}
        consentData={rolesData?.data}
        requestList={userList?.data}
        amountCount={amountCount}
      />

      <CloseRoleDrawer
        description={<>Are you sure to give approval for this request?</>}
        Textdescription={selectedRowData ? `${selectedRowData.reason} ` : ''}
        Icon={ApprovedModelIcon}
        showDrawer={showApprovalDrawer}
        setShowDrawer={setShowApprovalDrawer}
        onCloseClick={handleCloseClick}
        onApprove={handleApproveClick}
        closeText={'Back'}
        YesText={'Approve'}
        closeButtonHeight={'38px'}
        closeButtonWidth={'80px'}
        yesButtonHeight={'38px'}
        yesButtonWidth={'105px'}
      />

      <SucessfullPopup
        description={<p>Approval given!</p>}
        Icon={SuccessIcon}
        showDrawer={showSuccessPopup}
        setShowDrawer={setShowSuccessPopup}
        onCloseClick={closePopup}
      />

      <CloseRoleDrawer
        description={<>Are you sure to deny this request?</>}
        Textdescription={selectedRowData ? `${selectedRowData.reason} ` : ' '}
        Icon={ApprovedModelIcon}
        showDrawer={showDeclinedDrawer}
        setShowDrawer={setShowDeclinedDrawer}
        onCloseClick={handleDeclineCloseClick}
        onApprove={handleDeclineClick}
        closeText={'Back'}
        YesText={'Deny'}
        closeButtonHeight={'38px'}
        closeButtonWidth={'80px'}
        yesButtonHeight={'38px'}
        yesButtonWidth={'105px'}
      />

      <SucessfullPopup
        description={<p>Approval denied!</p>}
        Icon={DeclinedPopupIcon}
        showDrawer={showDeclinePopup}
        setShowDrawer={setShowDeclinePopup}
        onCloseClick={closeDeclinePopup}
      />
    </div>
  )
}

export default TpoApprovalTable
